import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Terms of Service | IntelliEats';
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-1340" data-mp="211c723hi7bqu">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1341" data-mp="13fn5c92davvd">
        <header className="mb-12" data-id="element-1342" data-mp="18cx5aindupxg">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-1343" data-mp="1dbhvdp8x7t86">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1344" data-mp="1heeklysyunl3" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-1345" data-mp="2oq3win3plfzx">
            <div className="bg-accent-100 text-accent-600 p-3 rounded-2xl" data-id="element-1346" data-mp="2srpakbrzc0bp">
              <FileText className="w-8 h-8" data-id="element-1347" data-mp="nx1r9acvzulv" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-1348" data-mp="nwa9b2c7pve2">
              Terms of Service
            </h1>
          </div>
          <p className="text-slate-500 text-sm" data-id="element-1349" data-mp="dyckacmj3uke">Last updated: April 7, 2025</p>
        </header>

        <div className="space-y-10 text-slate-700 leading-relaxed" data-id="element-1350" data-mp="9xtqid12sefk">
          <section data-id="element-1351" data-mp="9zmz3xv918q7">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1352" data-mp="4xxo2i810v24">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-1353" data-mp="77f6v0e6a2o">
              By downloading, installing, or using the IntelliEats mobile
              application ("App"), you agree to be bound by these Terms of
              Service ("Terms"). If you do not agree to these Terms, please do
              not use the App.
            </p>
          </section>

          <section data-id="element-1354" data-mp="3ic2fzc8awp3i">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1355" data-mp="3icarazorzmcl">
              2. Description of Service
            </h2>
            <p data-id="element-1356" data-mp="3dgdc4wp90m1e">
              IntelliEats is a mobile application that uses AI technology to
              scan and analyze ingredient labels on packaged food products. The
              App categorizes ingredients into "Safe," "Limited Intake," and
              "Ingredients to Avoid" based on available nutritional research and
              databases.
            </p>
          </section>

          <section data-id="element-1357" data-mp="2yt560aasr6wa">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1358" data-mp="3mh4vz80aat9t">
              3. Disclaimer
            </h2>
            <div className="bg-accent-50 rounded-2xl p-6 border border-accent-100" data-id="element-1359" data-mp="3rghg3kzrtm8p">
              <p className="m-0 font-medium text-slate-800" data-id="element-1360" data-mp="3crcx41l5jdzj">
                <strong data-id="element-1361" data-mp="3cqtfyn3bstmk">Important:</strong> IntelliEats is designed for
                informational purposes only and should not be considered medical
                or nutritional advice. The ingredient analysis provided by the
                App is based on general nutritional guidelines and may not
                account for individual health conditions, allergies, or dietary
                needs. Always consult with a qualified healthcare professional
                before making significant dietary changes.
              </p>
            </div>
          </section>

          <section data-id="element-1362" data-mp="27iiibunbtlss">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1363" data-mp="27j0jn5ouiq7k">
              4. User Responsibilities
            </h2>
            <ul className="space-y-3 list-none p-0" data-id="element-1364" data-mp="1fsmdjvn2qi6g">
              <li className="flex items-start gap-3" data-id="element-1365" data-mp="1ftfcwbjpe5ek">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-1366" data-mp="1atsy3xo88h3n"></span>
                <span data-id="element-1367" data-mp="1otarkqcgwijc">
                  You are responsible for ensuring the accuracy of scanned
                  images and labels
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1368" data-mp="1jswlhduffiny">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-1369" data-mp="307objk43odu3"></span>
                <span data-id="element-1370" data-mp="2v9wa9zhkffd8">
                  You agree not to use the App for any unlawful purpose
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1371" data-mp="3ql45sfnrwa0j">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-1372" data-mp="3vie7ouscme59"></span>
                <span data-id="element-1373" data-mp="4cmgds2u4vgv">
                  You acknowledge that scan results depend on image quality and
                  label clarity
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1374" data-mp="99cvod6tfn18">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-1375" data-mp="dbzsytm9a05t"></span>
                <span data-id="element-1376" data-mp="ibcbx3a0an34">
                  You agree not to reverse engineer, decompile, or disassemble
                  the App
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-1377" data-mp="s0vx4fl6yt15">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1378" data-mp="s1e343xnolm9">
              5. Intellectual Property
            </h2>
            <p data-id="element-1379" data-mp="wyxi5626h2f9">
              All content, features, and functionality of the App—including but
              not limited to text, graphics, logos, icons, and software—are the
              exclusive property of IntelliEats and are protected by
              international copyright, trademark, and other intellectual
              property laws.
            </p>
          </section>

          <section data-id="element-1380" data-mp="2ck847d8sx01z">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1381" data-mp="2clsyd1r7egzb">
              6. Limitation of Liability
            </h2>
            <p data-id="element-1382" data-mp="35959mfrwz2db">
              To the fullest extent permitted by applicable law, IntelliEats and
              its developer shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages arising out of or
              related to your use of the App. This includes, but is not limited
              to, any health-related decisions made based on the App's analysis.
            </p>
          </section>

          <section data-id="element-1383" data-mp="3o0ps2oyc1ud0">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1384" data-mp="3o0y3ecet4rm3">
              7. Pricing
            </h2>
            <p data-id="element-1385" data-mp="1hauq19bdevkc">
              The ingredient scanning feature of IntelliEats is free to use.
              Customization features may be available at a minimum cost. We
              reserve the right to modify pricing with reasonable notice to
              users.
            </p>
          </section>

          <section data-id="element-1386" data-mp="1ck5y5svs3wko">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1387" data-mp="1cjmea6mkiy40">
              8. Termination
            </h2>
            <p data-id="element-1388" data-mp="xlu29og8cruk">
              We reserve the right to terminate or suspend your access to the
              App at any time, without prior notice, for conduct that we believe
              violates these Terms or is harmful to other users, us, or third
              parties.
            </p>
          </section>

          <section data-id="element-1389" data-mp="tm36t7frdnjp">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1390" data-mp="tljxug8369ht">
              9. Changes to Terms
            </h2>
            <p data-id="element-1391" data-mp="2iydpp49bi1ca">
              We reserve the right to modify these Terms at any time. Continued
              use of the App after changes constitutes acceptance of the revised
              Terms.
            </p>
          </section>

          <section className="bg-brand-50 rounded-2xl p-8 border border-brand-100" data-id="element-1392" data-mp="2t4y4s29r3ta1">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1393" data-mp="36vbeoa67di20">
              10. Contact Us
            </h2>
            <p className="mb-4" data-id="element-1394" data-mp="324l5smykix2k">
              If you have any questions about these Terms, please contact us:
            </p>
            <p className="font-medium text-slate-900" data-id="element-1395" data-mp="3gs68ifrj6u9y">
              Email:{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 transition-colors" data-id="element-1396" data-mp="3btl92ik3semk">
                intellieats@gmail.com
              </a>
            </p>
            <p className="mt-2" data-id="element-1397" data-mp="3lqpw0klrwe4f">
              Or use our{' '}
              <Link to="/contact" className="text-brand-600 hover:text-brand-700 font-medium transition-colors" data-id="element-1398" data-mp="1vhfzx2j7nbbb">
                Contact Support
              </Link>{' '}
              page.
            </p>
          </section>
        </div>
      </div>
    </motion.div>;
}